import { InlineMessage } from '@strata/react-inline-message';

import { NewTemplateNote } from 'components/admin/automations/NewTemplateNote';

export const AutomationTips = () => (
    <div className="sds_automations__tips">
        <InlineMessage
            intent={InlineMessage.Intent.TIP}
            wrapText
            title="Using The Patient Template"
            label="The patient template can be used when you have a prescription 'in hand' for a new patient at your pharmacy. It allows you to identify the patient and place a bid in advance of the referral going live for all users. Remember, new medications for your existing patients will automatically be sent your way as a PENDING INTAKE task in your Worklist."
        />
        <NewTemplateNote />
    </div>
);
